import React, { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { VEHICLE_CATALOG, OTHER, findCategory } from "@/data/luxuryVehicles";

// Cascading Catégorie → Marque → Modèle. "Autre" à chaque niveau révèle un champ
// texte libre en MAJUSCULES — un véhicule unique ne bloque jamais la saisie.
export default function VehiclePicker({ initialBrand = "", initialModel = "", onChange }) {
  const categories = Object.keys(VEHICLE_CATALOG);
  const initCat = findCategory(initialBrand, initialModel);
  const catKnown = !!initCat;

  const [catSel, setCatSel] = useState(initialBrand ? (catKnown ? initCat : OTHER) : "");
  const [brandSel, setBrandSel] = useState(initialBrand ? (catKnown ? initialBrand : OTHER) : "");
  const [brandText, setBrandText] = useState(catKnown ? "" : initialBrand);
  const modelKnownInit = catKnown && (VEHICLE_CATALOG[initCat]?.[initialBrand] || []).includes(initialModel);
  const [modelSel, setModelSel] = useState(initialModel ? (modelKnownInit ? initialModel : OTHER) : "");
  const [modelText, setModelText] = useState(modelKnownInit ? "" : initialModel);

  const catIsOther = catSel === OTHER;
  const brandFree = catIsOther || brandSel === OTHER;
  const modelFree = brandFree || modelSel === OTHER;
  const brands = catSel && !catIsOther ? Object.keys(VEHICLE_CATALOG[catSel] || {}) : [];
  const models = brandSel && !brandFree ? (VEHICLE_CATALOG[catSel]?.[brandSel] || []) : [];

  const finalBrand = brandFree ? brandText : brandSel;
  const finalModel = modelFree ? modelText : modelSel;
  useEffect(() => { onChange(finalBrand, finalModel); /* eslint-disable-next-line */ }, [finalBrand, finalModel]);

  const up = (v) => v.toUpperCase();
  const onCat = (v) => { setCatSel(v); setBrandSel(""); setBrandText(""); setModelSel(""); setModelText(""); };
  const onBrand = (v) => { setBrandSel(v); setModelSel(""); setModelText(""); };

  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <Label>Catégorie</Label>
        <Select value={catSel} onValueChange={onCat}>
          <SelectTrigger data-testid="vehicle-category-select"><SelectValue placeholder="Sélectionner une catégorie" /></SelectTrigger>
          <SelectContent className="max-h-72">
            {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            <SelectItem value={OTHER}>{OTHER}…</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label>Marque</Label>
        {catIsOther ? (
          <Input value={brandText} onChange={(e) => setBrandText(up(e.target.value))} placeholder="MARQUE" className="uppercase" data-testid="vehicle-brand-other" />
        ) : (
          <>
            <Select value={brandSel} onValueChange={onBrand} disabled={!catSel}>
              <SelectTrigger data-testid="vehicle-brand-select"><SelectValue placeholder={catSel ? "Sélectionner une marque" : "Choisir d'abord la catégorie"} /></SelectTrigger>
              <SelectContent className="max-h-72">
                {brands.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}
                <SelectItem value={OTHER}>{OTHER}…</SelectItem>
              </SelectContent>
            </Select>
            {brandSel === OTHER && (
              <Input value={brandText} onChange={(e) => setBrandText(up(e.target.value))} placeholder="MARQUE" className="uppercase mt-2" data-testid="vehicle-brand-other" />
            )}
          </>
        )}
      </div>

      <div className="space-y-1.5">
        <Label>Modèle</Label>
        {modelFree ? (
          <Input value={modelText} onChange={(e) => setModelText(up(e.target.value))} placeholder="MODÈLE" className="uppercase" data-testid="vehicle-model-other" />
        ) : (
          <Select value={modelSel} onValueChange={setModelSel} disabled={!brandSel}>
            <SelectTrigger data-testid="vehicle-model-select"><SelectValue placeholder={brandSel ? "Sélectionner un modèle" : "Choisir d'abord la marque"} /></SelectTrigger>
            <SelectContent className="max-h-72">
              {models.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
              <SelectItem value={OTHER}>{OTHER}…</SelectItem>
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  );
}
